import _ from 'lodash';

// The ONE newest-first ordering used wherever a stored active assessment is
// unusable: the selector's auto-switch and read-only resolvers must agree.
export const sortAssessmentsNewestFirst = <T extends { createdAt?: string }>(assessments: T[]): T[] =>
  _.orderBy(assessments, 'createdAt', 'desc');
